import React from 'react';
import Skeleton from 'react-loading-skeleton';
import '../../../assets/styles/SearchPage/Utils/_search_card.sass';

const SearchCardSkeleton = () => {
  return (
    <div className="py-4 px-2 relative flex flex-col w-auto SmallCard">
      <div className="SmallCard__imgcontainer">
        {/* Imagen skeleton */}
        <Skeleton height={350} className="SmallCard__imgcontainer__img" />
      </div>
      
      <div className="SmallCard__infocontainer">
        <div className="SmallCard__infocontainer__data">
          {/* Tipo de propiedad */}
          <div className="SmallCard__infocontainer__data__type">
            <Skeleton width={120} height={16} />
          </div>
          
          {/* Título */}
          <div className="SmallCard__infocontainer__data__title">
            <Skeleton height={20} />
            <Skeleton width="80%" height={20} />
          </div>
          
          {/* Descripción con huéspedes, dormitorios, etc. */}
          <div className="SmallCard__infocontainer__data__description">
            <Skeleton width={200} height={16} />
          </div>
          
          {/* Reviews */}
          <div className="SmallCard__infocontainer__data__review">
            <div className="SmallCard__infocontainer__data__review__header">
              <div className="flex items-center gap-2">
                <Skeleton circle width={24} height={24} />
                <Skeleton width={100} height={16} />
              </div>
            </div>
            <div className="SmallCard__infocontainer__data__review__text">
              <Skeleton count={2} height={16} />
              <Skeleton width="60%" height={16} />
            </div>
          </div>
        </div>
        
        {/* Precio */}
        <div className="SmallCard__infocontainer__price">
          <div className="SmallCard__infocontainer__price__reviews">
            <Skeleton width={80} height={18} />
            <Skeleton width={120} height={24} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchCardSkeleton;